import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import apiFetchManualPreadviceTransactionsUpload from '../../api/RfidFileUploadAPI';
import { RFID_FILE_UPLOAD_REQUEST } from '../actions/types/RfidUploadActionsTypes';
import { uploadRfidFileSuccessActionCreator, uploadRfidFileFailureActionCreator } from '../actions/RfidFileUploadActions';
import { csvGetHeaders, compare } from '../../../../../../utils/csv';
import { languageSelector } from '../../../../../common/redux/selectors/languageSelector';
import { showNotification } from '../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../locales/locales';

// Order is important! Add new header values in alphabetical order.
export const allowedHeaders = [
  'cape_site_entry',
  'cape_site_exit',
  'part',
  'pb_id',
  'po_entry',
  'po_exit',
  'reg_time_entry',
  'reg_time_exit',
  'rfid_rp_entry',
  'rfid_rp_exit',
  'rfid_site_entry',
  'rfid_site_exit',
  'trip',
  'utc_time_entry',
  'utc_time_exit',
];

function* doRfidFileUploadWorker({ payload }) {
  const lang = yield select(languageSelector);

  try {
    const { file } = payload;

    if (!file) {
      const required = new Error('Required filed.');
      yield put(uploadRfidFileFailureActionCreator(required, {
        file: 'You should select a csv file.',
      }));
      return;
    }

    const headers = yield call(csvGetHeaders, file);

    const valid = compare(allowedHeaders, headers.sort());

    if (!valid) {
      const invalidCsv = new Error('Invalid CSV');
      yield put(uploadRfidFileFailureActionCreator(invalidCsv, {
        file: 'Invalid csv header. Please select a proper csv file.',
      }));
      return;
    }
    const res = yield call(apiFetchManualPreadviceTransactionsUpload, payload);
    yield put(uploadRfidFileSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.rfidfile.upload.success'),
    }));
  } catch (error) {
    yield put(uploadRfidFileFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'notification.rfidfile.upload.failure'),
    }));
  }
}

function* doRfidFileUploadWatcher() {
  yield takeLatest(RFID_FILE_UPLOAD_REQUEST, doRfidFileUploadWorker);
}

export default doRfidFileUploadWatcher;
